import { Box, Avatar, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurpleOutlineWarningIcon } from 'Images';

export const InfoBox = () => {
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];

  return (
    <Box
      role='button'
      sx={{
        width: '100%',
        padding: '20px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        margin: '5px 0',
      }}
    >
      <Avatar
        src={PurpleOutlineWarningIcon}
        sx={{
          width: '19px',
          height: '19px',
          alignSelf: 'flex-start',
        }}
        alt=''
      />
      <Typography sx={{ ml: 1 }} variant='body3'>
        {dictionary.uploadFile.fileInfo}
      </Typography>
    </Box>
  );
};
